var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainInsightsClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.389a11.111 11.111 0 1 0 0 22.222 11.111 11.111 0 0 0 0-22.222Zm0 20.833a9.722 9.722 0 1 1 0-19.444 9.722 9.722 0 0 1 0 19.444Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.139 12.777V7.465a.695.695 0 0 0-1.389 0v6.056l4.097 2.777a.695.695 0 1 0 .771-1.152l-3.48-2.369Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.555 12.459A6.903 6.903 0 0 1 16.257 6.66l.59-.944a8.02 8.02 0 1 0-5.924 14.583l.188-1.063a6.945 6.945 0 0 1-5.556-6.777Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h25v25H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainInsightsClockIcon);
export default __webpack_public_path__ + "static/media/main-insights-clock-icon.81f92b790a4e26a99df919f630ea6cdc.svg";
export { ForwardRef as ReactComponent };